import { threeJsVariables } from '../../../settings';

export class PerformanceAnalyzation {
	constructor () {
		this.frames = [];
		this.callback = (averageFPS) => {};
		this.start = 0;
		this.end = 0.5 * 60000;
		
		this.beginTime = ( performance || Date ).now();
		this.prevTime = this.beginTime;
		
		this.time = 0;
		
		threeJsVariables.composer.addUpdatableElement(this);
	}
	
	tick() {
		this.time = ( performance || Date ).now();
		
		if (this.time >= this.prevTime + 1000) {
			this.start += this.time - this.prevTime;
			this.frames.push(threeJsVariables.fps.framesPerSecond);
			this.prevTime = this.time;
		}
		
		if (this.start >= this.end) {
			this.start = 0;
			this.finish();
		}
	}
	
	finish() {
		threeJsVariables.composer.removeUpdatableElement(this);
		const averageFps = this.frames.reduce((acc,value) => acc += value,0) / this.frames.length;
		this.callback(averageFps);
	}
}
